import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = {
    key: 1,
    class: "small",
    style: { "color": "red", "margin-top": "-15px" }
};
const _hoisted_5 = {
    key: 2,
    class: "small",
    style: { "color": "#00ff00", "margin-top": "-15px" }
};
const _hoisted_6 = {
    key: 3,
    class: "small"
};
const _hoisted_7 = ["src", "onClick"];
const _hoisted_8 = ["src", "onClick"];
const _hoisted_9 = ["src", "onClick"];
const _hoisted_10 = ["src", "onClick"];
const _hoisted_11 = {
    key: 8,
    class: "select-radio-group"
};
const _hoisted_12 = { class: "radio-label" };
const _hoisted_13 = ["src", "onClick"];
const _hoisted_14 = ["src", "onClick"];
const _hoisted_15 = { key: 13 };
const _hoisted_16 = {
    key: 16,
    class: "small centered"
};
const _hoisted_17 = ["href"];
const _hoisted_18 = {
    key: 17,
    class: "field-error"
};
const _hoisted_19 = {
    key: 18,
    class: "small"
};
const _hoisted_20 = {
    key: 19,
    class: "help-text"
};
const _hoisted_21 = {
    key: 20,
    class: "not-listed"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    key: 21,
    class: "not-listed not-listed--manual"
};
const _hoisted_24 = { key: 0 };
const _hoisted_25 = ["onClick"];
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import AddressLookup from './AddressLookup.vue';
import FieldDrawer from './FieldDrawer.vue';
import DateFieldDrawer from './DateFieldDrawer.vue';
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputSections',
    props: {
        formatter: { default: () => ({}) },
        sections: {},
        theme: {},
        editMode: { type: Boolean, default: false },
        outline: { type: Boolean, default: false }
    },
    emits: ["notListedAction"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const { isDarkMode } = useDarkMode();
        const props = __props;
        const emit = __emit;
        const sectionNo = ref(0);
        const lastSectionNo = ref(0);
        const pageTheme = ref(props.theme);
        const showPasswords = ref(false);
        const manualEntryFields = ref({});
        let _handleTouchStart = null;
        const section = computed(() => {
            return props.sections[sectionNo.value];
        });
        const fieldVariant = computed(() => {
            return props.outline ? 'outlined' : 'solo';
        });
        const fieldFlat = computed(() => {
            return !props.outline;
        });
        function onLoad() {
            if (!pageTheme.value) {
                pageTheme.value = 'dark';
            }
        }
        function determineColour(field) {
            if (pageTheme.value == 'white') {
                return '#ffffff';
            }
            else if (pageTheme.value == 'dark') {
                return '#ffffffaa';
            }
            else {
                if (field.readOnly && props.editMode) {
                    return '#ffffffaa';
                }
                else {
                    return '#3328470D';
                }
            }
        }
        function next(sectionNumber) {
            sectionNo.value = sectionNumber;
        }
        function back(sectionNumber) {
            sectionNo.value = sectionNumber;
        }
        function handlePasswordKeyup(field) {
            let strongPass = false;
            if (field.value && field.value.length > 0) {
                strongPass = field.value.length > 7;
                if (strongPass) {
                    strongPass = /[A-Z]/.test(field.value) && /[a-z]/.test(field.value) && /\d/.test(field.value) && /[!@#$%^&*(),.?":{}|<>]/.test(field.value);
                }
            }
            field.strongPass = strongPass;
        }
        function handleKeyup(field, event) {
            const type = field.type.toLowerCase();
            if (type === 'datetext' && event.key !== 'Backspace' && field.value && (field.value.length == 2 || field.value.length == 5)) {
                field.value += '/';
            }
            else if (type === 'sortcode' && event.key !== 'Backspace' && field.value && (field.value.length == 2 || field.value.length == 5)) {
                field.value += '-';
            }
        }
        function handleKeydown(field, event) {
            const type = field.type.toLowerCase();
            if (['datetext', 'sortcode', 'currency', 'percent', 'accountnumber'].includes(type)) {
                if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && (type !== 'currency' && type !== 'percent' || event.key !== '.')) {
                    event.preventDefault();
                }
                if ((type === 'datetext' && field.value?.length >= 10) || (type === 'sortcode' && field.value?.length >= 8) || (type === 'accountnumber' && field.value?.length >= 8)) {
                    if (event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                        event.preventDefault();
                    }
                }
                if (type === 'currency' || type === 'percent') {
                    const value = field.value || '';
                    const decimalIndex = value.indexOf('.');
                    if (decimalIndex !== -1 && value.length - decimalIndex - 1 >= 2 && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                        event.preventDefault();
                    }
                }
            }
        }
        function determineDisabled(field) {
            if (field.readOnly && props.editMode) {
                return true;
            }
            return false;
        }
        function enableManualEntry(field) {
            field.value = '';
            manualEntryFields.value[field.id] = true;
            manualEntryFields.value = { ...manualEntryFields.value };
        }
        function disableManualEntry(field) {
            field.value = null;
            manualEntryFields.value[field.id] = false;
            manualEntryFields.value = { ...manualEntryFields.value };
        }
        __expose({ next, back });
        onMounted(() => {
            onLoad();
            _handleTouchStart = (e) => {
                var activeInput = document.activeElement;
                if (!activeInput || activeInput.tagName !== 'INPUT')
                    return;
                var container = e.target.closest('.v-input, .v-field, .inputSections > div');
                var newInput = e.target.tagName === 'INPUT' ? e.target : (container ? container.querySelector('input') : null);
                if (newInput && newInput !== activeInput) {
                    e.preventDefault();
                    newInput.focus({ preventScroll: true });
                }
            };
            document.addEventListener('touchstart', _handleTouchStart, { passive: false });
        });
        onBeforeUnmount(() => {
            if (_handleTouchStart) {
                document.removeEventListener('touchstart', _handleTouchStart);
            }
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            return (section.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["inputSections", [pageTheme.value, { 'is-dark-mode': _unref(isDarkMode) }]])
                }, [
                    (section.value.title)
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(section.value.title), 1))
                        : _createCommentVNode("", true),
                    (section.value.subtitle)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            innerHTML: section.value.subtitle
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.value.fields, (f) => {
                        return (_openBlock(), _createElementBlock("div", { key: f }, [
                            (['password'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: showPasswords.value ? 'text' : 'password',
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    autocomplete: "new-password",
                                    "append-icon": showPasswords.value ? 'mdi-eye' : 'mdi-eye-off',
                                    "onClick:append": _cache[0] || (_cache[0] = ($event) => (showPasswords.value = !showPasswords.value)),
                                    clearable: !determineDisabled(f),
                                    onChange: ($event) => (handlePasswordKeyup(f)),
                                    onKeyup: ($event) => (handlePasswordKeyup(f)),
                                    onKeydown: ($event) => (handleKeydown(f, $event)),
                                    "onClick:clear": ($event) => (f.strongPass = false),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => { f.value = ''; f.strongPass = false; }
                                        }, null, 8, _hoisted_3)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "type", "label", "variant", "disabled", "flat", "append-icon", "clearable", "onChange", "onKeyup", "onKeydown", "onClick:clear", "bg-color"]))
                                : _createCommentVNode("", true),
                            (['password'].includes(f.type.toLowerCase()) && !f.strongPass && f.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Weak Password"))
                                : _createCommentVNode("", true),
                            (['password'].includes(f.type.toLowerCase()) && f.strongPass)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Strong Password"))
                                : _createCommentVNode("", true),
                            (['password'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Passwords must be at least 8 characters, contain at least one upper case character, at least one lower case character, a number and a special character, such as one of the following: !@#$%&*?"))
                                : _createCommentVNode("", true),
                            (['number', 'text', 'email'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 4,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: f.type,
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    autocomplete: "new-email",
                                    clearable: !determineDisabled(f),
                                    onKeydown: ($event) => (handleKeydown(f, $event)),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => (f.value = '')
                                        }, null, 8, _hoisted_7)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "type", "label", "variant", "disabled", "flat", "clearable", "onKeydown", "bg-color"]))
                                : _createCommentVNode("", true),
                            (['accountnumber'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 5,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: "text",
                                    inputmode: "numeric",
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    clearable: !determineDisabled(f),
                                    onKeydown: ($event) => (handleKeydown(f, $event)),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => (f.value = '')
                                        }, null, 8, _hoisted_8)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "variant", "disabled", "flat", "clearable", "onKeydown", "bg-color"]))
                                : _createCommentVNode("", true),
                            (['currency'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 6,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: "text",
                                    inputmode: "decimal",
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    prefix: "£",
                                    placeholder: "0.00",
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    clearable: !determineDisabled(f),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => (f.value = '')
                                        }, null, 8, _hoisted_9)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "variant", "disabled", "flat", "clearable", "bg-color"]))
                                : _createCommentVNode("", true),
                            (['percent'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 7,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: "number",
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    suffix: "%",
                                    placeholder: "0",
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    clearable: !determineDisabled(f),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => (f.value = '')
                                        }, null, 8, _hoisted_10)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "variant", "disabled", "flat", "clearable", "bg-color"]))
                                : _createCommentVNode("", true),
                            (f.type == 'select')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("p", _hoisted_12, _toDisplayString(f.label) + " " + _toDisplayString(f.required ? '*' : ''), 1),
                                    _createVNode(_component_v_radio_group, {
                                        modelValue: f.value,
                                        "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                        inline: "",
                                        disabled: determineDisabled(f)
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.items, (i) => {
                                                return (_openBlock(), _createBlock(_component_v_radio, {
                                                    key: i,
                                                    label: i,
                                                    value: i
                                                }, null, 8, ["label", "value"]));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                ]))
                                : _createCommentVNode("", true),
                            (f.type == 'dropdown' && !manualEntryFields.value[f.id])
                                ? (_openBlock(), _createBlock(FieldDrawer, {
                                    key: 9,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    label: f.label,
                                    items: f.items,
                                    required: f.required,
                                    disabled: determineDisabled(f),
                                    clearable: !determineDisabled(f),
                                    subtitle: f.drawerSubtitle,
                                    notListedText: f.notListedMessage ? f.notListedMessage + (f.notListedAction ? '' : '') : null,
                                    showAvatars: f.showAvatars === true,
                                    theme: pageTheme.value
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "items", "required", "disabled", "clearable", "subtitle", "notListedText", "showAvatars", "theme"]))
                                : _createCommentVNode("", true),
                            (f.type == 'dropdown' && manualEntryFields.value[f.id])
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 10,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: "text",
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    clearable: !determineDisabled(f),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => (f.value = '')
                                        }, null, 8, _hoisted_13)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "variant", "disabled", "flat", "clearable", "bg-color"]))
                                : _createCommentVNode("", true),
                            (f.type == 'date' || f.type.toLowerCase() == 'datetext')
                                ? (_openBlock(), _createBlock(DateFieldDrawer, {
                                    key: 11,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    label: f.label,
                                    required: f.required,
                                    disabled: determineDisabled(f),
                                    clearable: !determineDisabled(f),
                                    theme: pageTheme.value
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "required", "disabled", "clearable", "theme"]))
                                : _createCommentVNode("", true),
                            (['sortcode'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 12,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    type: f.type,
                                    label: f.label + ' ' + (f.required ? '*' : ''),
                                    variant: fieldVariant.value,
                                    disabled: determineDisabled(f),
                                    flat: fieldFlat.value,
                                    clearable: !determineDisabled(f),
                                    onKeyup: ($event) => (handleKeyup(f, $event)),
                                    onKeydown: ($event) => (handleKeydown(f, $event)),
                                    "bg-color": determineColour(f)
                                }, {
                                    clear: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: require('@/assets/clearx.png'),
                                            class: "clear-x",
                                            onClick: ($event) => (f.value = '')
                                        }, null, 8, _hoisted_14)
                                    ]),
                                    _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "type", "label", "variant", "disabled", "flat", "clearable", "onKeyup", "onKeydown", "bg-color"]))
                                : _createCommentVNode("", true),
                            (['radio'].includes(f.type.toLowerCase()))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("p", null, _toDisplayString(f.label) + ":", 1),
                                    _createVNode(_component_v_radio_group, {
                                        modelValue: f.value,
                                        "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                        inline: ""
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.items, (i) => {
                                                return (_openBlock(), _createBlock(_component_v_radio, {
                                                    key: i,
                                                    label: i,
                                                    value: i
                                                }, null, 8, ["label", "value"]));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]))
                                : _createCommentVNode("", true),
                            (f.type == 'check')
                                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                    key: 14,
                                    class: "check",
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event),
                                    label: f.label,
                                    "bg-color": determineColour(f)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "bg-color"]))
                                : _createCommentVNode("", true),
                            (f.type == 'address')
                                ? (_openBlock(), _createBlock(AddressLookup, {
                                    key: 15,
                                    theme: pageTheme.value,
                                    showNumber: false,
                                    value: f.value,
                                    modelValue: f.value,
                                    "onUpdate:modelValue": ($event) => ((f.value) = $event)
                                }, null, 8, ["theme", "value", "modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true),
                            (f.link)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("a", {
                                        href: f.link
                                    }, _toDisplayString(f.linkLabel), 9, _hoisted_17)
                                ]))
                                : _createCommentVNode("", true),
                            (f.errorText)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(f.errorText), 1))
                                : _createCommentVNode("", true),
                            (f.subtitle)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(f.subtitle), 1))
                                : _createCommentVNode("", true),
                            (f.helpText)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(f.helpText), 1))
                                : _createCommentVNode("", true),
                            (f.notListedMessage && !manualEntryFields.value[f.id] && !f.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("p", null, _toDisplayString(f.notListedMessage), 1),
                                    (f.notListedAction)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: ($event) => (enableManualEntry(f))
                                        }, _toDisplayString(f.notListedAction), 9, _hoisted_22))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (f.notListedMessage && manualEntryFields.value[f.id])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (f.notListedActionedMessage)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(f.notListedActionedMessage), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("a", {
                                        onClick: ($event) => (disableManualEntry(f))
                                    }, "Back to list", 8, _hoisted_25)
                                ]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
